var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 44,
    viewBox: "0 0 145 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_3057)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5756 33.4223C46.1842 33.4223 43.7898 31.8212 43.0766 29.1212H46.781C47.2613 30.0528 48.4767 30.4676 49.5319 30.4676C51.3077 30.4676 52.6031 29.2668 52.6031 27.6075V26.5959L52.0791 26.9306C51.1185 27.542 49.9977 27.8622 48.8406 27.8622C45.2454 27.8622 42.6327 25.2349 42.6327 21.6179C42.6327 18.0009 45.3036 15.3664 48.8406 15.3664C50.3034 15.3664 51.657 15.8613 52.7487 16.8001L53.0762 17.0766L53.753 15.7812H56.2565V27.0907C56.2565 30.9916 53.6948 33.4223 49.5756 33.4223ZM49.5902 18.423C47.7707 18.423 46.4535 19.7694 46.4535 21.6179C46.4535 23.4665 47.7707 24.8274 49.5902 24.8274C51.4096 24.8274 52.7196 23.4737 52.7196 21.6179C52.7196 19.7621 51.4023 18.423 49.5902 18.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0887 28.6336C62.0277 28.6336 59.0803 25.839 59.0803 21.9964C59.0803 18.1537 62.0277 15.3591 66.0887 15.3591C70.1496 15.3591 73.0971 18.1537 73.0971 21.9964C73.0971 25.839 70.1496 28.6336 66.0887 28.6336ZM66.0887 18.7287C64.2547 18.7287 62.9229 20.1042 62.9229 21.9964C62.9229 23.8886 64.2547 25.264 66.0887 25.264C66.9766 25.264 67.7844 24.9365 68.3593 24.3471C68.9343 23.7576 69.2545 22.9206 69.2545 21.9964C69.2545 20.1042 67.9227 18.7287 66.0887 18.7287Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.7562 11.0507H75.9208V28.2042H79.7562V11.0507Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.6395 28.2042V18.8597H82.4708V15.9923H84.6905V14.3985C84.6905 11.8949 86.0296 10.5777 88.5695 10.5777H91.3787V13.3577H89.7266C88.8679 13.3577 88.3147 13.9108 88.3147 14.7623V15.9923H91.4005V18.8597H88.4603V28.2042H84.625H84.6395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.247 28.6336C99.8426 28.6336 98.5472 28.1751 97.5138 27.3091L97.1644 27.018L96.6477 28.2042H93.8749V11.0507H97.652V16.5454L98.1687 16.2252C99.0712 15.6648 100.134 15.3737 101.247 15.3737C105.097 15.3737 107.79 18.1028 107.79 22.0036C107.79 25.9045 105.097 28.6336 101.247 28.6336ZM100.643 18.6705C98.7801 18.6705 97.3682 20.1042 97.3682 22.0036C97.3682 23.9031 98.7728 25.3223 100.643 25.3223C102.514 25.3223 103.918 23.8958 103.918 22.0036C103.918 20.1114 102.514 18.6705 100.643 18.6705Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.61 28.6336C112.746 28.6336 109.835 25.7735 109.835 21.9818C109.835 18.1901 112.688 15.3518 116.61 15.3518C120.533 15.3518 123.415 18.0955 123.415 21.8654C123.415 22.1346 123.401 22.4185 123.364 22.7169H113.517L113.597 23.1244C113.918 24.7692 114.988 25.6789 116.61 25.6789C117.702 25.6789 118.641 25.2204 119.165 24.4489H122.986C121.996 27.0398 119.587 28.6263 116.603 28.6263L116.61 28.6336ZM116.61 18.2047C115.133 18.2047 114.1 19.0125 113.685 20.468L113.561 20.8974H119.769L119.638 20.4608C119.194 19.0052 118.124 18.2047 116.61 18.2047Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21 28.2042V15.7812H128.677L129.514 17.506L129.856 17.113C130.693 16.1451 131.726 15.7157 133.211 15.7157H134.062V19.1653H132.65C130.875 19.1653 130.045 20.0241 130.045 21.8799V28.2042H126.21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.119 28.2042C139.411 28.2042 137.803 26.5813 137.803 23.8594V18.5758H135.401V17.9936L141.078 11.9459H141.515V15.7739H144.804V18.5686H141.624V23.0807C141.624 24.2015 142.352 24.9293 143.48 24.9293H144.87V28.2042H142.104H142.119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00546 6C3.58062 6 0 9.58062 0 13.9982H8.00546V6Z",
    fill: "#5DC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 6H23.9945V14.0055H32V6Z",
    fill: "#D3F489"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00546 14.0055H0V22.0109H8.00546V14.0055Z",
    fill: "#39A844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1985 6H10.6691H8.00546V14.0055H16.0036H21.2217L23.9945 12.5208V6H19.1985Z",
    fill: "#98DC64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4853 22.0042L8.00546 14.0133V22.0042H16.0036H18.4853Z",
    fill: "#5DC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2217 14.0055H16.0036H8.00546V14.0127H21.2217V14.0055Z",
    fill: "#5DC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9945 14.0055L23.9654 14.0127L20.9525 22.0036H23.9945H32V14.0055H23.9945Z",
    fill: "#5DC43F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0036 29.0339L18.5363 22.0036H17.5538H16.0036V29.0339Z",
    fill: "#39A844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 22.0036H23.9945H20.9525L20.1592 24.1869L18.0414 30.0018H23.9945H32V22.0036Z",
    fill: "#39A844"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9945 30.0018H18.0414L15.9964 35.6275V38H23.9945C28.4121 38 31.9927 34.4194 31.9927 30.0018H23.9873H23.9945Z",
    fill: "#158C48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.647 30.0018H8.00546H0C0 34.4194 3.58062 38 7.99818 38H12.7432L15.647 30.0018Z",
    fill: "#0E7738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1376 38H16.0036V35.6275L15.1376 38Z",
    fill: "#0E7738"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0036 29.0339V22.0036H8.00546H0V30.0018H8.00546H15.647L16.0036 29.0339Z",
    fill: "#158C48"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_3057"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144.884,
    height: 32,
    fill: "white",
    transform: "translate(0 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrand);
export default __webpack_public_path__ + "static/media/Brand.6e7297e0e89a9538d9187e3f37606da0.svg";
export { ForwardRef as ReactComponent };